import {FetchDataError} from 'apstra-ui-common';
import React from 'react';
import {ErrorBoundary as ErrorBoundaryInt} from 'react-error-boundary';

export const ErrorBoundary: React.FC<React.PropsWithChildren> = ({
  children
}) => (
  <ErrorBoundaryInt
    fallbackRender={({error}) => <FetchDataError error={error} />}
  >
    {children}
  </ErrorBoundaryInt>
);

export const withErrorBoundary = <T extends object, >(Component: React.FC<T>): React.FC<T> => (props: T) => {
  return (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );
};
